<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>MIS POSTULACIONES</h1>
                    <p class="mt-3">
                        Ayúdanos a elegir a que familia de productos perteneces.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-ofertas']" class="nav-link m-1">Listado de ofertas</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-proveedor']" class="nav-link m-1 disabled" tabindex="-1" aria-disabled="true">Mis postulaciones</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-registro']" class="nav-link m-1"> Actualizar registro </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-contrasena']" class="nav-link m-1"> Actualizar Contraseña </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/login']" class="nav-link cerrar m-1 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 text-center mx-auto">

                <div class="FlstLi table-responsive">
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Código</th>
                            <th scope="col" class="pl-2 pr-2">Producto</th>
                            <th scope="col" class="pl-2 pr-2">Fecha publicación</th>
                            <th scope="col" class="pl-2 pr-2">Etapa</th>
                            <th scope="col" class="pl-2 pr-2">Postulación</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq">
                            <tr *ngFor="let postulacion of postulaciones">
                                <td>{{postulacion.codigo}}</td>
                                <td>{{postulacion.producto}}</td>
                                <td>{{postulacion.fechaPublicacion}}</td>
                                <td>{{postulacion.etapa}}</td>
                                <!-- <td (click)="showPdf(oferta.archivo_ficha_tecnica, oferta.nombre_ficha_tecnica)">
                                    <img src="../../../assets/images/iconos/ficha-tecnica.svg" class="ficha">
                                </td>
                                <td>{{oferta.detalle_oferta}}</td>
                                <td>{{oferta.familia}}</td> -->
                                <td class="pl-2 pr-2 align-middle"> 
                                    <div class="form-group col-sm-12 pt-1 m-0 text-center">
                                        <button class="btn-aceptar redBtn" (click)="change(postulacion)"> Eliminar </button>
                                    </div>
                                </td>
        
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-12 blqCtr alerta-confirmar text-center" *ngIf="this.confirma">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-trash.png">
            <p>
                Está a punto de <strong>eliminar</strong> su participación en esta oferta, <strong>¿desea continuar?</strong>
            </p>
            <button class="mr-2 redBtn" (click)="goChange()"> Eliminar</button>
            <button class="ml-2 greyBtn" (click)="cancel()"> Cancelar</button>
        </div>
        <div class="col-12 blqCtr alerta-exito text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-exito.png">
            <p>
                Ya <strong>no está participando</strong> por esta oferta, le invitamos a seguir viendo nuestro <strong>catálogo.</strong>
            </p>
            <button class="btn" (click)="closeok()">Aceptar</button>
        </div>
        <div class="col-12 blqCtr alerta-registro text-center" *ngIf="this.fail">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>
                Una vez calificado debe esperar 30 días para una nueva participación.
            </p>
            <button class="btn" (click)="closeok()">Aceptar</button>
        </div>

	</div>

</div>